<template>
  <div class="main-report">
    <div v-if="timeReport.length > 0 && !timeReportBusy">
      <table>
        <tr>
          <th>ID</th>
          <th>Name</th>
          <th>Register</th>
          <th>Deposit</th>
          <th>Scheduled Call</th>
          <th>NA</th>
          <th>NI</th>
          <th>REG-DEP-DIFF</th>
          <th>REG-SC-DIFF</th>
          <th>DEP-NA-DIFF</th>
          <th>NA-NI-DIFF</th>
          <th>SC-DEP-DIFF</th>
        </tr>
        <tr v-for="client in timeReport" :key="client">
          <td>{{ client["client"].id }}</td>
          <td>{{ client["client"].full_name }}</td>
          <td>{{ client.register_time }}</td>
          <td>{{ client.deposit_time }}</td>
          <td>{{ client.first_sc_time }}</td>
          <td>{{ client.last_na_time }}</td>
          <td>{{ client.last_ni_time }}</td>
          <td>{{ client["register-deposit-diff"] }}</td>
          <td>{{ client["register-sc-diff"] }}</td>
          <td>{{ client["na-deposit-diff"] }}</td>
          <td>{{ client["na-ni-diff"] }}</td>
          <td>{{ client["sc-deposit-diff"] }}</td>
        </tr>
      </table>
    </div>
    <div class="loader-div" v-if="timeReportBusy">
      <!--      <loader :size="'8px'"></loader>-->
      <span class="insteadLoader"
        >CREATING REPORT ,PLEASE WAIT
        <div class="snippet" data-title=".dot-flashing">
          <div class="stage">
            <div class="dot-flashing"></div>
          </div>
        </div>
      </span>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapState} from "vuex";
import apiClientCreator from "../../../../../helpers/api/request";
import UsersPermissionCheck from "../../../../../mixins/user/auth/UsersPermissionCheck";
import Loader from "../../../../../main/misc.main/loader/Loader";

export default {
  name: "TimeMeasurementReport.container",
  // components: { Loader },
  mixins: [UsersPermissionCheck],
  data() {
    return {
      timeReport: [],
      timeReportBusy: false
    };
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapState("clients", ["dictionaries", "salesPersonList"])
  },
  created() {
    this.getTimeMeasurementReport();
  },
  methods: {
    async getTimeMeasurementReport() {
      if (!this.timeReportBusy && this.CheckUserPermission([1, 2, 3, 4, 12])) {
        try {
          this.timeReportBusy = true;
          const res = await apiClientCreator(
            `reports/deposits/time_measure`
          ).get("");
          this.timeReport = res.data["last_week"];
          this.timeReportBusy = false;
        } catch (e) {}
      }
    }
  }
};
</script>

<style scoped>
table tr:nth-of-type(2n + 1) {
  background: #f5f7ff;
}
table tr:hover {
  background: #eceff1;
}
table,
th,
td {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 0.5em 0.4em;
}
th {
  font-size: smaller;
}
.main-report {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5em 0;
}
/**
 * ==============================================
 * Dot Flashing
 * ==============================================
 */
.dot-flashing {
  position: relative;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  background-color: red;
  color: red;
  animation: dotFlashing 1s infinite linear alternate;
  animation-delay: 0.5s;
}

.dot-flashing::before,
.dot-flashing::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
}

.dot-flashing::before {
  left: -15px;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  background-color: red;
  color: red;
  animation: dotFlashing 1s infinite alternate;
  animation-delay: 0s;
}

.dot-flashing::after {
  left: 15px;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  background-color: red;
  color: red;
  animation: dotFlashing 1s infinite alternate;
  animation-delay: 1s;
}

@keyframes dotFlashing {
  0% {
    background-color: red;
  }
  50%,
  100% {
    background-color: #ebe6ff;
  }
}
.stage {
  position: absolute;
  left: 110%;
  top: 48%;
}
.insteadLoader {
  color: red;
  position: absolute;
  left: 45%;
  top: 100px;
}
</style>
